import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navItems, site } from "../data/site";
import { projects } from "../data/projects";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const currentProject = projects.find((project) => location.pathname === `/games/${project.slug}` && project.storeUrl);

  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="header-inner">
        <Link to="/" className="brand" aria-label="SZ Interactive home" onClick={() => setOpen(false)}>
          <span className="brand-mark logo-mark"><img src="/assets/brand/logo.png" alt="" /></span>
          <span>
            <strong>SZ Interactive</strong>
            <small>Independent game studio</small>
          </span>
        </Link>
        <button
          className="icon-button menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="primary-navigation"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
        </button>
        <nav id="primary-navigation" className={open ? "nav is-open" : "nav"} aria-label="Primary navigation">
          {navItems.map((item) => (
            <NavLink key={item.href} to={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </NavLink>
          ))}
          <a href={site.instagram} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}>
            Social
          </a>
          {currentProject && (
            <a className="nav-cta" href={currentProject.storeUrl} target="_blank" rel="noreferrer">
              {currentProject.title === "JEFF" ? "Wishlist JEFF" : "Wishlist The Shed"}
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}
